export default "curl -X POST {{url}} -H \"api-key: {{apiKey}}\" -T \"{{path}}\"\n"